import {
    deleteData,
    getData,
    postData,
    putData,
    uploadExcel,
} from "../Config/AxiosConfig";

// Add Order
export const addOrder = async (body) => {
    return await postData("order", body);
};

// CSV Upload
export const addCSV = async (formData) => {
    return await uploadExcel("order/upload", formData);
};

// Get Orders
export const getOrders = async (params) => {
    const cleanedParams = Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v !== "" && v !== undefined)
    );

    const query = new URLSearchParams(cleanedParams).toString();

    return await getData(`orders?${query}`);
};

// Update Order
export const updateOrder = async (id, body) => {
    return await putData(`order/${id}`, body);
};

// Delete Order
export const deleteOrder = async (id) => {
    return await deleteData(`order/${id}`);
};

// Confirmed Orders
export const getConfirmedOrders = async (params) => {
    const cleanedParams = Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v !== "" && v !== undefined)
    );

    cleanedParams.is_confirmed = "confirmed";

    const query = new URLSearchParams(cleanedParams).toString();

    console.log("Final API Query:", query);

    return await getData(`orders?${query}`);
};

// Update Status
export const updateOrderStatus = async (id, status) => {
    return await putData(`orders/${id}/status`, { status });
};

// Bulk Status
export const bulkUpdateOrderStatus = async (ids, status) => {
    return await putData(`orders/bulk-status`, { ids, status });
};

// Bulk Update
export const updateBulkOrder = async (body) => {
    return await putData(`orders-bulk-update`, body);
};